// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductCollections = (client) => ({
    /**
     * `GET /vendor/product-collections`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductCollections
     * @source packages/modules/b2c-core/src/api/vendor/product-collections/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-collections", { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-collections/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductCollectionsIdProductsRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/product-collections/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/vendor/product-collections/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/product-collections/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetProductCollectionById
     * @source packages/modules/b2c-core/src/api/vendor/product-collections/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/product-collections/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=product-collections.js.map